
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			AIR PIPE LINE WORKS
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../assets/img/active-product/pipe-line.jpeg" alt="">
        <br>
        <ul>
            <li>Air pipeline systems are designed to transport compressed air through a network of pipes to various points in industrial facilities, workshops, and manufacturing units. 
                They provide the necessary airflow for machinery, tools, and systems that rely on compressed air for operation.

            &nbsp;Regular maintenance ensures your air pipeline system is free of leaks, blockages,
             and other issues that can cause pressure loss and operational downtime.

             Maintenance & Cleaning – Regular cleaning and inspections
              to keep pipelines clear of debris, moisture, and contaminants that can affect performance.</li>
        </ul>



        <p>
            Expert Technicians – Our skilled technicians are experienced in designing, installing, and maintaining air pipeline systems for various industries.
            Reduces energy consumption and lowers operational costs.
            Increases the lifespan of equipment relying on compressed air.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand6.webp" alt="">
    <br>
    <ul>
        <li>Panel air coolers are designed to regulate temperature in electrical panels
             and enclosures, preventing overheating of critical components. They use evaporative cooling to lower the temperature inside panels, ensuring the proper functioning of sensitive electronic equipment and prolonging their lifespan.

        &nbsp;Ideal for industrial environments, control rooms, server rooms, manufacturing units, and electrical substations where temperature
         control is crucial for equipment reliability and performance.
         Panel air coolers play a critical role in maintaining the right temperature within control panels. Regular servicing ensures optimal 
         airflow, prevents system failures, and helps avoid costly downtime.</li>
    </ul>



    <p>
        Installation & Setup – Proper installation of new panel air coolers to ensure efficient cooling and integration with existing systems.
    <p>
        Routine Maintenance – Regular checks, cleaning of filters, and inspection of electrical connections to ensure peak performance.
        Repairs & Replacements – Fast troubleshooting and repair of any issues, including fan malfunctions, motor failures, or cooling inefficiencies.
        Energy Efficiency Upgrades – Improving the energy efficiency of existing air coolers to reduce operational costs.
    </p>
    </div>


